import { PkButton, PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import config from 'utils/config';

export interface RegulationsData {
  isDesktop: boolean;
}
export const Regulations = (isDesktop: RegulationsData) => {
  const { t } = useTranslation();
  const regulationLink = config.regulationLink;

  return (
    <div className="pk-m--0 pk-px--m pk-px-md--l pk-py--l pk-py-md--xl pk-px-md--m pk-py--0">
      <div
        className={clsx({
          'pk-font-size--xl pk-font-style--normal pk-text--text-01 pk-font--comp-bold pk-line-height--sm': true,
          'pk-line-height--md': isDesktop,
        })}
      >
        {t('regulations')}
      </div>
      <div className="pk-py--xl">
        <div className="pk-m--0">
          <PkButton
            appearance="text"
            type="button"
            link-href={regulationLink}
            link-target="_blank"
            link-button
            className="pk-font-size--m pk-font-weight--bold pk-line-height--lg"
          >
            {t('regulations_of_the_competition')} <PkIcon name="navigation-chevron-right" />
          </PkButton>
        </div>
      </div>
    </div>
  );
};
